import React, { Component } from 'react';
import { Card, Modal } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';

import DescriptionList from '@comm/DescriptionList';
import TipsOverdue from '../../comm/TipsOverdue';
import TableAppoint from './TableAppoint';
import ComSeatTable from '../../seat/ComSeatTable';
import TableFile from '../../comm/TableFile';

const { Description } = DescriptionList;
class Open extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataItem: this.props.data,
      seatVisible: false,
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    this.setState({
      dataItem: nextProps.data,
    });
  }

  handleSeatVisible = flag => {
    this.setState({
      seatVisible: !!flag,
    });
  };

  findTypeName = type => {
    let typeName = '';
    this.props.expendType.forEach(item => {
      if (type === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  handleVisible = flag => {};

  render() {
    const { dataItem, seatVisible } = this.state;
    const { payables } = this.props;
    const { business } = dataItem;
    const extra = <TipsOverdue interval={dataItem.interval} />;
    return (
      <div className="form-open mb16">
        <Card title={extra}>
          <DescriptionList size="large" col={3}>
            <Description term="合同编号">{business.no}</Description>
            <Description term="孵化器">{business.incubator}</Description>
            <Description term="客户">{business.custom}</Description>
            <Description term="项目">{business.projectName}</Description>
            <Description term="收入类型">
              {business.type === 'settled' ? <span>工位收入</span> : null}
              {business.type === 'oregistapp' ? <span>地址收入</span> : null}
            </Description>
            <Description term="合同费用">{business.businessPrice}</Description>
            <Description term="押金">{business.deposit}</Description>
            <Description term="工位数量">
              <a onClick={() => this.handleSeatVisible(true)}>{business.num}</a>
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={3}>
            <Description term="记租时间">
              {moment.unix(business.beginDate / 1000).format('YYYY-MM-DD')}
            </Description>
            <Description term="到期时间">
              {moment.unix(business.endDate / 1000).format('YYYY-MM-DD')}
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={3}>
            <Description term="终止开始时间">
              {moment.unix(dataItem.beginDate / 1000).format('YYYY-MM-DD')}
            </Description>
            <Description term="终止结束时间">
              {moment.unix(dataItem.endDate / 1000).format('YYYY-MM-DD')}
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={1}>
            <Description term="附件">
              <TableFile dataSource={dataItem.files || []} disabled />
            </Description>
          </DescriptionList>
          <DescriptionList size="large" col={2}>
            <Description term="终止合同说明">{dataItem.reason}</Description>
          </DescriptionList>
          <div>
            <TableAppoint data={payables || []} />
          </div>
        </Card>
        <Modal
          visible={seatVisible}
          width={900}
          title="选择工位"
          onCancel={() => this.handleSeatVisible(false)}
          onOk={this.handleSetStation}
          footer={false}
        >
          <ComSeatTable
            {...this.props}
            incubatorUuid={business.incubatorUuid}
            handleChange={this.handleStationChange}
            stations={business ? business.stations : []}
            disabled
            ref={node => {
              this.seatTable = node;
            }}
          />
        </Modal>
      </div>
    );
  }
}
export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(Open);



// WEBPACK FOOTER //
// ./src/components/incubator/termination/station/FormOpen.js